import baseUrl from '@pocapan/shared/utils/baseUrl';
import getToken from '@pocapan/shared/utils/getToken';
import type { ReviewableAPIResponseType } from '../types/ReviewableType';

export const getReviewablePhotoCard = async () => {
  try {
    const response = await fetch(`${baseUrl()}/api/v2/trading_photo_cards/reviewable`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`
      }
    });
    if (response.ok) {
      const data: ReviewableAPIResponseType = await response.json();
      return data.reviewableTradingPhotoCards;
    }
  } catch {
    throw new Error('Failed to fetch reviewable photo card');
  }
};
